export default __webpack_public_path__ + "static/media/season_1_mapfull.3bbd5b04.png";